import { render } from "./StartupPage.vue?vue&type=template&id=f132bcf4&ts=true"
import script from "./StartupPage.vue?vue&type=script&lang=ts"
export * from "./StartupPage.vue?vue&type=script&lang=ts"

import "./StartupPage.vue?vue&type=style&index=0&id=f132bcf4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__